// extracted by mini-css-extract-plugin
export default {"LogoSimpleBanner":"LogoSimpleBanner_LogoSimpleBanner__qenF-","link":"LogoSimpleBanner_link__8Oxt1","logo":"LogoSimpleBanner_logo__heahf"};